// extracted by mini-css-extract-plugin
module.exports = {"solution-wrapper":"F4nu1","solutionWrapper":"F4nu1","box-wrapper":"_2Vtg7","boxWrapper":"_2Vtg7","icon":"_29Scr"};